import $ from 'jquery';

var selectors = {
  countBadge: '.js-header__cart-articles-count'
};

export function init() {
  $.subscribe('update.header:cart', updateCounter);
}

export function destroy() {
  $.unsubscribe('.header:cart');
}

function updateCounter(event, newVal) {
  $(selectors.countBadge).text(newVal);
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/header/cart.js
 **/